export default {
    heading: 'Dodajte popust',
    discount: 'Popusti',
    discount_title: 'Popust',
    title: {
        label: 'Naziv popusta',
        placeholder: 'Unesite naziv popusta',
    },
    date_from: {
        label: 'Od datuma',
        placeholder: 'Unesite datum',
    },
    date_to: {
        label: 'Do datuma',
        placeholder: 'Unesite datum',
    },
    percentage: {
        label: 'Procenat',
        placeholder: 'Unesite procenat',
    },
    price: {
        label: 'Nova cijena',
        placeholder: 'Unesite novu cijenu',
    },
    offer: {
        label: 'Usluga',
        placeholder: 'Izaberite uslugu',
    },
    category: {
        label: 'Kategorije',
        placeholder: 'Izaberite kategorije',
    },

    table: {
        offer: 'Usluga',
        category: 'Kategorija',
        title: 'Naslov',
        date_from: 'Datum od',
        date_to: 'Datum do',
        percentage: 'Procenat',
        actions: 'Akcije',
    },
    discount_info: 'Popust će se obračunati za sve rezervacije napravljene u konfigurisanom vremenskom periodu.',
    delete_discount: 'Da li ste sigurni da želite da obrišete popust?',
    warning: 'Trenutno nemate nijedan popust!',
}
